import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=54d3a52e&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d3a52e')) {
      api.createRecord('54d3a52e', component.options)
    } else {
      api.reload('54d3a52e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=54d3a52e&", function () {
      api.rerender('54d3a52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Main.vue"
export default component.exports